<template>
  <AppWithLoading :fetch="fetchVacancyLists">
    <template v-slot:default="{loader}">
      <div class="qr-alert" v-if="noActiveState">
        <img src="../../assets/img/qr/qr-alert.svg" alt="">
        {{ $t('badLists') }}
      </div>
      <div v-if="vacancyLists.length">
        <template v-if="vacancyLists">
          <VacancyListItem
            v-for="vacancyList of vacancyLists"
            :key="vacancyList.id"
            :vacancy-list="vacancyList"
            @destroyed="loader(() => fetchWhenDestroyed())"
          />
        </template>
        <template v-if="metaData && metaData.lastPage > 1">
          <v-pagination
            :value="page"
            @input="loader(()=> loadPage($event))"
            :length="metaData.lastPage"
          />
        </template>
      </div>
      <div v-else>
        {{ $t('noVacancyLists') }}
      </div>
    </template>
  </AppWithLoading>
</template>

<script>
import AppWithLoading from '@/components/AppWithLoading';
import VacancyListItem from '@/components/VacancyLists/VacancyListItem';
import { ref } from '@vue/composition-api';
import useVacanciesList from '@/compositions/useVacanciesList';

export default {
  name: 'VacancyListItems',
  components: { VacancyListItem, AppWithLoading },
  setup() {
    const page = ref(1);
    const noActiveState = ref(false);
    const {
      fetchAll, metaData, vacancyLists, getNoActiveState,
    } = useVacanciesList();

    async function fetchVacancyLists() {
      noActiveState.value = await getNoActiveState();
      await fetchAll(page.value, 15);
    }

    async function loadPage(newPage) {
      await fetchVacancyLists(newPage, 15);
      page.value = newPage;
    }

    async function fetchWhenDestroyed() {
      if (page.value !== 1 && vacancyLists.value?.length === 1) {
        page.value -= 1;
        await fetchVacancyLists();
      } else {
        await fetchVacancyLists();
      }
    }

    return {
      page,
      vacancyLists,
      metaData,
      fetchVacancyLists,
      loadPage,
      noActiveState,
      fetchWhenDestroyed,
    };
  },
};
</script>

<style lang="scss" scoped>
  .qr-alert {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    line-height: 1.14;
    color: #EA0D0D;
    margin-bottom: 1.5625rem;
    img {
      min-width: 1.8125rem;
      margin-right: 0.75rem;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .qr-alert {
      font-size: 0.75rem;
      line-height: 1.3;
      margin-bottom: 1.125rem;
      img {
        min-width: 1.625rem;
        margin-right: 0.75rem;
      }
    }
  }

</style>

<i18n lang="yml" locale="ru">
noVacancyLists: Вы ещё не создали подборку вакансий
badLists: У вас есть подборки, в которых все вакансии перешли в архив
</i18n>
<i18n lang="yml" locale="en">
noVacancyLists: You have not created any job selections yet
badLists: Some selections are empty (all jobs have been archived)
</i18n>
